/* ============================================================
   THS3 MOTION EXTRAS — supplements the official handoff motion
   system in ths3.js (slideshow / word reveal / marquee / steps).
   Adds only what the handoff doesn't cover:
     1. Pointer-follow 3D tilt on cards (desktop only).
   Disabled under prefers-reduced-motion.

   REMOVED 2026-08-14 — the .stat__n count-up that used to live
   here. ths3-life.js grew its own count-up for the same elements,
   so BOTH ran on the homepage trust strip and raced each other:

     · ths3-life.js observes at threshold 0.4, this file at 0.6.
     · Scrolling in, 0.4 always trips first. life starts animating
       and rewrites .stat__n to its first eased frame — "0+".
     · A moment later 0.6 trips, this file read that live text as
       its source value, so it counted 0 → 0 and, finishing last,
       had the final word: "0+" frozen on screen.

   It only bit when the two thresholds were crossed in separate
   frames — slow scroll, or a short viewport where the row takes
   longer to reach 60% — which is why one device showed 0+ and
   the next showed 2,00,000+. One owner now: ths3-life.js, which
   also preserves Indian digit grouping and restores the authored
   string exactly. Do not re-add a count-up here.
   ============================================================ */
(function () {
  'use strict';
  /* theme patch: static in the Shopify theme editor (see ths3.js note) */
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var reduced = designMode || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) return;

  /* ── 1 · pointer-follow card tilt ── */
  if (window.matchMedia('(pointer:fine)').matches) {
    var tiltEls = document.querySelectorAll('.card, .ct, .feat, .gk__card');
    Array.prototype.forEach.call(tiltEls, function (el) {
      el.addEventListener('pointermove', function (ev) {
        var r = el.getBoundingClientRect();
        var px = (ev.clientX - r.left) / r.width - 0.5;
        var py = (ev.clientY - r.top) / r.height - 0.5;
        el.style.setProperty('--ry', (px * 7).toFixed(2) + 'deg');
        el.style.setProperty('--rx', (-py * 7).toFixed(2) + 'deg');
        el.classList.add('ths3-tilt');
      });
      el.addEventListener('pointerleave', function () {
        el.classList.remove('ths3-tilt');
        el.style.removeProperty('--rx');
        el.style.removeProperty('--ry');
      });
    });
  }
})();

/* ============================================================
   PRODUCT-CARD IMAGE SLIDESHOW — every image of a product cycles
   inside its grid card. Desktop: hover auto-plays, click opens the
   product. Touch: first tap starts the show (not navigation), title
   or buttons open the product. Arrows shuffle manually everywhere.
   Event-delegated: survives filtering, pagination and the theme
   editor's section re-renders. Autoplay honors reduced motion.
   ============================================================ */
(function () {
  'use strict';
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var reduced = designMode || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;
  var timers = new WeakMap();

  function frames(show) { return show.querySelectorAll('.cardshow__img'); }
  function current(show) {
    var f = frames(show);
    for (var i = 0; i < f.length; i++) if (f[i].classList.contains('cur')) return i;
    return 0;
  }
  function go(show, n) {
    var f = frames(show);
    if (f.length < 2) return;
    n = (n + f.length) % f.length;
    var dots = show.querySelectorAll('.cardshow__dots i');
    Array.prototype.forEach.call(f, function (img, i) { img.classList.toggle('cur', i === n); });
    Array.prototype.forEach.call(dots, function (d, i) { d.classList.toggle('on', i === n); });
  }
  function play(show) {
    if (reduced || timers.get(show)) return;
    show.classList.add('is-playing');
    timers.set(show, setInterval(function () { go(show, current(show) + 1); }, 1600));
  }
  function stop(show) {
    var t = timers.get(show);
    if (t) { clearInterval(t); timers.delete(show); }
    show.classList.remove('is-playing');
  }

  /* manual arrows (always available, even under reduced motion) */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-cardshow-prev], [data-cardshow-next]');
    if (!btn) return;
    ev.preventDefault();
    ev.stopPropagation();
    var show = btn.closest('[data-cardshow]');
    if (!show) return;
    go(show, current(show) + (btn.hasAttribute('data-cardshow-next') ? 1 : -1));
  }, true);

  if (fine) {
    /* desktop: hover auto-plays, leaving stops; clicking navigates as usual */
    document.addEventListener('mouseover', function (ev) {
      var show = ev.target.closest('[data-cardshow]');
      if (show && !show.contains(ev.relatedTarget)) play(show);
    });
    document.addEventListener('mouseout', function (ev) {
      var show = ev.target.closest('[data-cardshow]');
      if (show && !show.contains(ev.relatedTarget)) stop(show);
    });
  }
  /* touch: NO click handler on the card image.
     Until 2026-08-06 the first tap on a product photo called
     preventDefault() and started the slideshow instead of opening
     the product — "Product opens via the title / Add to Cart" was
     the old comment. On a phone the 164×164 photo is the largest
     and most obvious target on the card, and tapping it did not
     navigate. Combined with the two 44px arrows that covered 52%
     of that photo (now hidden below 750px in ths3-mobile.css),
     the mobile grid actively blocked the path to the PDP.
     The <a class="cardshow"> wrapping the images is left to behave
     like the link it is. The arrow handler above still runs on
     tablets, in the capture phase with stopPropagation, so the
     arrows navigate frames without following the link. */
})();
